// Bau-Animation im Kopfbereich: Protokoll-Schritte laufen ab, Balken füllt sich,
// danach „fertig“ und Wechsel zum nächsten Demo-Shop. Ohne Bewegung (reduced motion) bleibt der Endzustand stehen.
if (typeof customElements !== 'undefined' && !customElements.get('sf-build')) {
  customElements.define('sf-build', class extends HTMLElement {
    connectedCallback() {
      this.demos = [...this.querySelectorAll('template[data-build-demo]')].map((tpl) => ({ ...tpl.dataset }));
      this.steps = [...this.querySelectorAll('[data-build-step]')];
      this.picks = [...this.querySelectorAll('[data-build-pick]')];
      this.stepMs = Number(this.dataset.stepMs || 900);
      this.index = 0;
      this.timers = [];
      this.picks.forEach((button) => button.addEventListener('click', () => this.show(Number(button.dataset.buildPick), true)));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || this.demos.length === 0) return;
      this.demos.forEach((demo) => { new Image().src = demo.desktop; new Image().src = demo.mobile; });
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        if (this.visible && !this.running) this.run();
      }, { threshold: 0.25 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.clear();
    }

    clear() {
      this.timers.forEach(clearTimeout);
      this.timers = [];
    }

    later(fn, ms) {
      this.timers.push(setTimeout(fn, ms));
    }

    setProgress(done) {
      const pct = Math.round((done / this.steps.length) * 100);
      this.querySelector('[data-build-bar]').style.width = `${pct}%`;
      this.querySelector('[data-build-pct]').textContent = `${pct} %`;
    }

    run() {
      this.clear();
      this.running = true;
      this.classList.add('is-building');
      this.steps.forEach((step) => step.classList.remove('is-done', 'is-active'));
      this.querySelector('[data-build-done]').classList.remove('is-visible');
      this.setProgress(0);
      this.steps.forEach((step, i) => {
        this.later(() => step.classList.add('is-active'), i * this.stepMs);
        this.later(() => {
          step.classList.remove('is-active');
          step.classList.add('is-done');
          this.setProgress(i + 1);
        }, (i + 1) * this.stepMs);
      });
      const end = (this.steps.length + 1) * this.stepMs;
      this.later(() => {
        this.querySelector('[data-build-done]').classList.add('is-visible');
        this.classList.remove('is-building');
      }, end);
      this.later(() => {
        this.running = false;
        if (!this.visible || this.pinned) return;
        this.show((this.index + 1) % this.demos.length);
      }, end + 2600);
    }

    show(index, pinned = false) {
      this.pinned = pinned;
      const demo = this.demos[index];
      if (!demo) return;
      this.index = index;
      this.picks.forEach((button, i) => button.classList.toggle('is-active', i === index));
      this.classList.add('is-switching');
      this.later(() => {
        const desktop = this.querySelector('[data-sf-devices-desktop]');
        const mobile = this.querySelector('[data-sf-devices-mobile]');
        desktop.src = demo.desktop;
        desktop.alt = `Beispiel-Shop ${demo.name} am Desktop`;
        mobile.src = demo.mobile;
        mobile.alt = `Beispiel-Shop ${demo.name} am Handy`;
        this.querySelector('[data-build-title]').textContent = `${demo.name} · ${demo.niche}`;
        this.classList.remove('is-switching');
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.run();
      }, 350);
    }
  });
}
